/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Trimp_One_LinerInputs */

const en_exp_trimp_one_liner = /** @type {(inputs: Exp_Trimp_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimates workout stress from heart rate data using the Banister formula.`)
};

const de_exp_trimp_one_liner = /** @type {(inputs: Exp_Trimp_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schätzt die Trainingsbelastung aus der Herzfrequenz — per Banister-Formel.`)
};

/**
* | output |
* | --- |
* | "Estimates workout stress from heart rate data using the Banister formula." |
*
* @param {Exp_Trimp_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_trimp_one_liner = /** @type {((inputs?: Exp_Trimp_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Trimp_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_trimp_one_liner(inputs)
	return de_exp_trimp_one_liner(inputs)
});